import React from "react";
import Skeleton from "@mui/material/Skeleton";

import * as Styles from "./styles";

const SkeletonGrid = () => {
  return (
    <>
      <Styles.Row>
        <Skeleton variant="rectangular" width="60%" height={40} />
        <span style={{ width: 8 }} />
        <Skeleton variant="rectangular" width="20%" height={40} />
        <span style={{ width: 8 }} />
        <Skeleton variant="rectangular" width="10%" height={40} />
        <span style={{ width: 8 }} />
        <Skeleton variant="rectangular" width="10%" height={40} />
      </Styles.Row>
      <span style={{ height: 32, display: "block" }} />
      <Styles.Row>
        <Skeleton variant="rectangular" width="20%" height={247} />
        <span style={{ width: 32 }} />
        <Skeleton variant="rectangular" width="20%" height={247} />
        <span style={{ width: 32 }} />
        <Skeleton variant="rectangular" width="20%" height={247} />
        <span style={{ width: 32 }} />
        <Skeleton variant="rectangular" width="20%" height={247} />
        <span style={{ width: 32 }} />
        <Skeleton variant="rectangular" width="20%" height={247} />
        <span style={{ width: 32 }} />
        <Skeleton variant="rectangular" width="20%" height={247} />
      </Styles.Row>
      <span style={{ height: 32, display: "block" }} />
      <Styles.Row>
        <Skeleton variant="rectangular" width="20%" height={247} />
        <span style={{ width: 32 }} />
        <Skeleton variant="rectangular" width="20%" height={247} />
        <span style={{ width: 32 }} />
        <Skeleton variant="rectangular" width="20%" height={247} />
        <span style={{ width: 32 }} />
        <Skeleton variant="rectangular" width="20%" height={247} />
        <span style={{ width: 32 }} />
        <Skeleton variant="rectangular" width="20%" height={247} />
        <span style={{ width: 32 }} />
        <Skeleton variant="rectangular" width="20%" height={247} />
      </Styles.Row>
    </>
  );
};

export default SkeletonGrid;
